var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesOrNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.197 16.3944C44.3257 19.4378 40.0649 11.5248 32.7623 20.6552C24.0217 20.6552 35.804 37.09 13.2834 39.5248C-6.80445 26.7422 14.8911 4.82916 23.6316 4.82916C32.3721 4.82916 43.717 5.43786 49.197 16.3944Z",
    fill: "url(#paint0_linear_335_13905)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5008 2.89996C14.5568 2.89996 3.30078 14.156 3.30078 28.1C3.30078 42.044 14.5568 53.3 28.5008 53.3C42.4448 53.3 53.7008 42.044 53.7008 28.1C53.7008 14.156 42.4448 2.89996 28.5008 2.89996ZM28.5008 5.69996C36.9008 5.69996 44.2928 10.3481 48.1008 17.236C45.9168 15.6679 43.2848 14.7719 40.4288 14.7719C33.0928 14.7719 27.1008 20.7639 27.1008 28.0999C27.1008 33.8679 22.3968 38.6279 16.5728 38.6279C10.7488 38.6279 6.10078 33.8679 6.10078 28.0999C6.10078 15.7239 16.1248 5.69996 28.5008 5.69996ZM28.5008 50.5C20.1008 50.5 12.7088 45.8519 8.90078 38.964C11.0848 40.5321 13.7168 41.428 16.5728 41.428C23.9088 41.428 29.9008 35.436 29.9008 28.1C29.9008 22.332 34.6048 17.572 40.4288 17.572C46.2528 17.572 50.9008 22.332 50.9008 28.1C50.9008 40.476 40.8768 50.5 28.5008 50.5Z",
    fill: "#827677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9015 32.86L22.5094 26.308L20.4933 24.2918L15.9014 28.9399L12.7095 25.6918L10.6934 27.708L15.9015 32.86Z",
    fill: "#EDECF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0281 25.1319L44.0681 23.1719L41.1 26.14L38.1319 23.1719L36.1719 25.1319L39.14 28.1L36.1719 31.0681L38.1319 33.0281L41.1 30.06L44.0681 33.0281L46.0281 31.0681L43.06 28.1L46.0281 25.1319Z",
    fill: "url(#paint1_linear_335_13905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_335_13905",
    x1: 2.13551,
    y1: 49.9335,
    x2: 59.4967,
    y2: 24.5234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_335_13905",
    x1: 37.5764,
    y1: 36.9706,
    x2: 52.3097,
    y2: 23.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesOrNo);
export default __webpack_public_path__ + "static/media/yes-or-no.49c8640ce0e2e40e1941dbd4c3b04028.svg";
export { ForwardRef as ReactComponent };